import { Route, Routes } from "react-router-dom";
import React from "react";
import PagesData from "./routedata";
import { routerType } from "../utils/types/props.route";
import ProtectedRoute from "../components/ProtectedRoute/ProtectedRoute";

const Router = () => {
  const pageRoutes = PagesData.map(
    ({ path, title, element, requiresAuth }: routerType) => {
      const WrappedElement = requiresAuth ? (
        <ProtectedRoute>{element}</ProtectedRoute>
      ) : (
        element
      );
      return <Route key={title} path={`/${path}`} element={WrappedElement} />;
    }
  );

  return <Routes>{pageRoutes}</Routes>;
};

export default Router;
